import * as types from './_actionTypes';

export const fetchStudentResultsRequest = () => ({
  type: types.FETCH_STUDENT_RESULTS_REQUEST
});

export const fetchStudentResultsSuccess = (results) => ({
  type: types.FETCH_STUDENT_RESULTS_SUCCESS,
  payload: results
});

export const fetchStudentResultsFailure = (error) => ({
  type: types.FETCH_STUDENT_RESULTS_FAILURE,
  payload: error
});

export const fetchCertificatesRequest = () => ({
  type: types.FETCH_CERTIFICATES_REQUEST
});

export const fetchCertificatesSuccess = (certificates) => ({
  type: types.FETCH_CERTIFICATES_SUCCESS,
  payload: certificates
});

export const fetchCertificatesFailure = (error) => ({
  type: types.FETCH_CERTIFICATES_FAILURE,
  payload: error
});

// Simplified to accept only certificateId - data fetching handled in saga
export const downloadCertificateRequest = (certificateId) => ({
  type: types.DOWNLOAD_CERTIFICATE_REQUEST,
  payload: { certificateId }
});

export const downloadCertificateSuccess = (certificateId) => ({
  type: types.DOWNLOAD_CERTIFICATE_SUCCESS,
  payload: certificateId,
  meta: { certificateId }
});

export const downloadCertificateFailure = (error, certificateId) => ({
  type: types.DOWNLOAD_CERTIFICATE_FAILURE,
  payload: error,
  meta: { certificateId }
});